import React, { useState } from "react";
import useStyles from "./styles";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const MaterialTopics = ({ materialTopicsTable, setMaterialTopicsTable }) => {
  const classes = useStyles();
  const handleInputChange = (categoryIndex, field, value) => {
    const updatedData = [...materialTopicsTable];
    updatedData[categoryIndex][field] = value;
    setMaterialTopicsTable(updatedData);
  };
  const [canAddMore, setCanAddmore] = useState(true);
  const [canRemove, setCanRemove] = useState(materialTopicsTable.length > 1);
  const handleAddMore = () => {
    setMaterialTopicsTable((prev) => [
      ...prev,
      {
        materialTopic: "",
        materialImpact: "",
        actualPotential: "",
        materialImpactType: "",
        materialTimeFrame: "",
        affectedResources: "",
        materialLocation: "",
      },
    ]);
    setCanRemove(true);
  };
  const handleRemove = () => {
    setMaterialTopicsTable((prev) => {
      setCanRemove(prev.length > 2);
      return prev.slice(0, -1);
    });
  };
  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          borderRadius: "6px",
          overflow: "hidden",
          // border: "1px solid #ddd",
        }}
      >
        <table border="2" style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", textAlign: "center" }}>
              <th style={{ padding: "8px" }}>Material topic</th>
              <th style={{ padding: "8px" }}>Impact (brief description)</th>
              <th style={{ padding: "8px" }}>Actual/Potential</th>
              <th style={{ padding: "8px" }}>
                Impact type (negative/positive/both)
              </th>
              <th style={{ padding: "8px" }}>Time frame</th>
              <th style={{ padding: "8px" }}>
                Affected Resources/Stakeholders
              </th>
              <th style={{ padding: "8px" }}>Geographic Location</th>
            </tr>
          </thead>
          <tbody>
            {materialTopicsTable?.map((item, categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                <tr key={`${categoryIndex}`}>
                  {/* Only render the category cell for the first row of each category */}
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.materialTopic}
                      placeholder="Enter Material Topic"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "materialTopic",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.materialImpact}
                      placeholder="Impact type"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "materialImpact",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.actualPotential}
                      placeholder="Actual/Potential"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "actualPotential",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.materialImpactType}
                      placeholder="Impact Type"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "materialImpactType",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.materialTimeFrame}
                      placeholder="Time Frame"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "materialTimeFrame",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.affectedResources}
                      placeholder="Affected Resource"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "affectedResources",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                  <td className={classes.marketDataRow}>
                    <textarea
                      value={item.materialLocation}
                      placeholder="Geographic Location"
                      onChange={(e) =>
                        handleInputChange(
                          categoryIndex,
                          "materialLocation",
                          e.target.value
                        )
                      }
                      className={classes.marketDataItem}
                    />
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <div className={classes.addMoreDiv}>
          <Box
            display="flex"
            paddingY={2}
            paddingLeft={2}
            gap={1}
            onClick={canRemove ? handleRemove : null}
            style={{
              cursor: canRemove ? "pointer" : "not-allowed",
              color: canRemove ? "gray" : "gray",
              border: "1px solid #ddd",
              padding: "2px 7px",
              margin: "5px 5px",
              borderRadius: "5px",
            }}
          >
            <RemoveIcon />
            <Typography>Remove</Typography>
          </Box>
          <Box
            display="flex"
            paddingY={2}
            paddingLeft={2}
            gap={1}
            onClick={canAddMore ? handleAddMore : null}
            style={{
              cursor: canAddMore ? "pointer" : "not-allowed",
              color: canAddMore ? "gray" : "gray",
              border: "1px solid #ddd",
              padding: "2px 7px",
              margin: "5px 5px",
              borderRadius: "5px",
            }}
          >
            <AddIcon />
            <Typography>Add More</Typography>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default MaterialTopics;
